/**
 * CameraIcon — A video camera: a camera wherever one is drawn. Hugeicons video-02 (MIT).
 */

import svg from './svg/camera.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const CameraIcon = makeSvgIcon('camera', svg);
